import React from 'react';
import _ from 'lodash';

import {
  useApplyListingManagementStrategyTemplateGroupsMutation,
  useApplyTemplatesToStoreModalQuery
} from 'generated/graphql';
import { TransferList } from 'modules';



export interface ITemplateGroup extends TransferList.IItem {
  id: string;
}

export interface IData {
  templates: ITemplateGroup[];
 }

export function useQuery() {
  const tuple = useApplyTemplatesToStoreModalQuery({});

  return React.useMemo(
    () => {
      const data: IData = {
        templates: _.map(tuple.data?.listingManagementStrategyTemplateGroups.nodes, (node): ITemplateGroup => ({
          id: node.id,
          primaryText: node.name,
          secondaryText: `${node.templateCount} items`
        }))
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}



export function useApplyListingManagementStrategyTemplateGroups(storeId: string) {
  const [fnMutate, tuple] = useApplyListingManagementStrategyTemplateGroupsMutation({
    refetchQueries: []
  });

  const fnWrappedMutate = React.useCallback(
    async (templateGroupIds: string[]) => {
      await fnMutate({
        variables: {
          input: {
            storeId,
            templateGroupIds
          }
        }
      });
    },
    [
      fnMutate,
      storeId
    ]
  );

  return React.useMemo(
    () => [
      fnWrappedMutate,
      {
        ...tuple,
        data: null
      }
    ] as const,
    [
      fnWrappedMutate,
      tuple
    ]
  );
}
